import React, { useState, useEffect } from "react";
import Api from "../services/api";

export default function SelectExperienciasCategorias(props) {
  const [faqTopicsList, setFaqTopicsList] = useState([]);

  useEffect(() => {
    loadFaqTopics();
  }, []);

  function loadFaqTopics() {
    Api.get("/experiencias/categorias/list")
      .then((response) => {
        setFaqTopicsList(response.data);
      })
      .catch((err) => {
        console.error("ops! ocorreu um erro" + err);
      });
  }

  let rows =
    faqTopicsList &&
    faqTopicsList.map((categoria, index) => {
      return (
        <option
          value={categoria.id}
          selected={props.selected == categoria.id ? true : false}
          key={index}
        >
          {categoria.nome_pt}
        </option>
      );
    });

  return (
    <select {...props.register} onChange={props.handleChange}>
      {rows}
    </select>
  );
}
